(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bokja-collective-invite"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bokja-collective-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.dataset.bokjaCollectiveOpen);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
    }
  });

  // NO re-open on the post-back, since 2026-08-20 (it existed 08-12→08-20). Shopify's
  // customer form is a full page POST, and this dialog used to re-open itself on
  // `form_type=customer` so the person saw the done-state they had earned. The signup
  // acknowledgement pop-up (snippets/bokja-signup-ack.liquid, rendered by the footer on
  // every page) now owns that moment for BOTH forms — two dialogs racing showModal() put
  // this one on top and hid the other (Malou saw exactly that). The done-state below stays:
  // it still renders if the dialog is re-opened by hand after a post.
  } catch(e) { console.error(e); }
})();

})();
